module.exports = __webpack_public_path__ + "static/media/empty_cart.c229e6fb.jpg";